import { learningServiceRequest, skip } from "./utils";

const productTypeService = {
  async getFinancialProductTypes({ limit = 150, page = 1, q }) {
    return await learningServiceRequest({
      method: "get",
      url: "/financial_product_types",
      params: {
        limit,
        skip: skip(page, limit),
        q,
      },
    });
  },
  async getSingleFinancialProductType({ product_type_id = "" }) {
    return await learningServiceRequest({
      method: "get",
      url: `/financial_product_types/${product_type_id}`,
      failureMessage: "Error loading Financial Product Type data",
    });
  },
};

export default productTypeService;
